'use client';

import { useEffect, useState } from 'react';
import { type AutoplayType } from 'embla-carousel-autoplay';

import { CarouselApi } from '@components/ui/Carousel';
import Typography from '@components/ui/Typography';
import FeedbackCarousel from '@components/homeSections/Feedback/FeedbackCarousel/FeedbackCarousel';
import FeedbackCarouselArrows from '@components/homeSections/Feedback/FeedbackCarousel/FeedbackCarouselArrows';

import { cn } from '@utils/cn';

const testimonials = [
  {
    author: 'Michael F.',
    text: `I get so many positive reactions when I present my 'We the people' Coign card for payment, especially from younger folks!`,
  },
  {
    author: 'Nancie K.',
    text: 'Just got mine in the mail... Can’t wait to start using it and put the others in a drawer!',
  },
  {
    author: 'Monica S.',
    text: 'I was ready to get mine as soon as I heard about it and I made my first purchases today with my new card! 🥰 🇺🇸 I love it!',
  },
  {
    author: 'Jimmy H.',
    text: `LOVE the new website! Happy to see things coming together and looking forward to seeing features added. I've got to give Coign props... They are really doing this! Excited to support a company with my values!`,
  },
  {
    author: 'Marlene T.',
    text: 'We love everything about this credit card! It is accepted everywhere and does exactly what they say it will do.',
  },
];

interface FeedbackProps {
  fullWidth?: boolean;
  className?: string;
}

export default function Feedback({ fullWidth, className }: FeedbackProps) {
  const [api, setApi] = useState<CarouselApi | null>(null);
  const [plugin, setPlugin] = useState<AutoplayType | null>(null);

  const [currentIndex, setCurrentIndex] = useState(0);

  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!api) return;

    api.on('select', () => {
      setCurrentIndex(api.selectedScrollSnap());
    });
  }, [api]);

  const isFirstSlide = currentIndex === 0;

  const isLastSlide =
    currentIndex === testimonials.length - (windowWidth >= 1440 ? 2 : 1);

  return (
    <div
      className={cn(
        'relative col-span-full h-auto min-h-[447px] w-full bg-surfaceVariant p-0',
        !fullWidth && 'sm:px-10 sm:py-6 lg:px-20',
        className
      )}
    >
      <div
        className={cn(
          'size-full bg-secondary py-20 pl-4 sm:pl-10',
          !fullWidth && 'sm:rounded-2xl'
        )}
      >
        <div className="flex h-full flex-col items-end gap-8 sm:gap-20 md:flex-row md:items-center md:justify-between">
          <div className="w-full text-left md:w-2/5">
            <Typography intent="displayMedium" className="text-white">
              <span className="sm:hidden">
                WHAT OUR PEOPLE
                <br />
                ARE <span className="text-primary">SAYING</span>
              </span>
              <span className="hidden sm:inline">
                WHAT OUR
                <br />
                PEOPLE ARE
                <br />
                <span className="text-primary">SAYING</span>
              </span>
            </Typography>
            <FeedbackCarouselArrows
              isFirstSlide={isFirstSlide}
              isLastSlide={isLastSlide}
              api={api}
              plugin={plugin}
            />
          </div>
          <FeedbackCarousel
            setApi={setApi}
            setPlugin={setPlugin}
            testimonials={testimonials}
            isLastSlide={isLastSlide}
          />
        </div>
      </div>
    </div>
  );
}
